import { getProductGroupsGridFactory } from '@bingads-webui-campaign/product-groups-grid';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { setProductGroupFactory } from './src/get-set-grid-factory';
import pkg from './package.json';

export { ProductGroupsEditBidsView } from './src/common/view/product-groups-edit-bid';

export const { version } = pkg;

export default globalContext.define(
  pkg.legacyDependencies,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (Promise) => { // eslint-disable-line no-unused-vars, arrow-body-style
    return getProductGroupsGridFactory(false).then(({ createProductGroupsGrid }) => {
      setProductGroupFactory(createProductGroupsGrid);
      return import(/* webpackMode: 'eager' */ './src/index');
    });
  }
);
